<template>
  <v-row>
    <v-col cols="12" class="pt-0" v-if="hosting_error">
      <v-card class="app-card" text>
        <v-card-text>
          <p class="mb-0">{{ hosting_error }}</p>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" v-else>
      <v-row>
        <v-col cols="12">
          <reseller-packages />
        </v-col>
        <v-col cols="12">
          <reseller-feature-lists />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import ResellerFeatureLists from 'Components/Services/Hosting/Reseller/ResellerFeatureLists'
import ResellerPackages from 'Components/Services/Hosting/Reseller/ResellerPackages'

export default {
  name: 'HostingWhmPackages',
  components: {
    ResellerFeatureLists,
    ResellerPackages,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: mapGetters(['hosting_error']),
}
</script>
